// extracted by mini-css-extract-plugin
export default {"wrapper":"wq-z","reviewFormSuccess":"xq-z","header":"yq-z","message":"zq-z","paragraph":"Aq-z","lottieContainer":"Bq-z"};